import sileo from 'sileo';

const ServiceContract = new sileo.Model('bposeats', 'service-contract');
const ContractPolicy = new sileo.Model('bposeats', 'contract-policy');
const EmploymentContract = new sileo.Model('bposeats', 'employment-contract');
const Contracts = new sileo.Model('hqzen', 'employment-contract');
const UnsignedContractsCount = new sileo.Model('hqzen', 'unsigned-employment-contracts-count');
const NextEmploymentContract = new sileo.Model('bposeats', 'next-employment-contract');
const JobOfferContractItem = new sileo.Model('bposeats', 'job-offer-accepted-contract');
const JobOfferContractSignature = new sileo.Model('bposeats', 'contract-signature');
const ContractSignature = new sileo.Model('hqzen', 'contract-signature');
const AllContracts = new sileo.Model('applybpo', 'hr-admin-employment-contracts');
const Signature = new sileo.Model('generic_form', 'signature');
const JobOfferContractDetails = new sileo.Model('bposeats', 'contract-details');
const ContractComment = new sileo.Model('bposeats', 'contract-comment');
const ContractCommentAmazonCredentials = new sileo.Model('bposeats', 'comment-attachment-amazon-form-data');
const ContractCommentSeen = new sileo.Model('bposeats', 'contract-comment-seen');
const ContractUnreadCommentsCount = new sileo.Model('bposeats', 'contract-unread-comments-count');
const EmploymentContractList = new sileo.Model('hqzen', 'employment-contract-list');
const EmploymentContractDetails = new sileo.Model('hqzen', 'employment-contract-details');

const state = {};

const getters = {};

const mutations = {};

const actions = {
    getServiceContract: function(context, pk) {
        return ServiceContract.objects.get(pk);
    },

    submitServiceContract: function(context, data) {
        // process signature blob first before sending update post request to API
        const [signature, contract_id, payload] = data;
        return new Promise((resolve) => {
            const formData = new FormData();
            Object.entries(payload).forEach(([key, value]) => {
                formData.append(key, value);
            });
            signature.save((blob) => {
                formData.append('signature_file', blob);
                resolve(formData);
            });
        }).then(formData => {
            return ServiceContract.objects.update({ pk: contract_id }, formData);
        });
    },

    fetchAllEmploymentContract(context, filter) {
        return JobOfferContractItem.objects.filter(filter);
    },

    fetchJobOfferContractDetails(context, filter) {
        return JobOfferContractDetails.objects.filter(filter);
    },

    getJobOfferContractDetails(context, pk) {
        return JobOfferContractDetails.objects.get(pk);
    },

    createContractPolicy(context, data) {
        return ContractPolicy.objects.create(data);
    },

    fetchAllContractPolicies(context, filters) {
        return ContractPolicy.objects.filter(filters);
    },

    fetchEmploymentContracts(context, filters) {
        return EmploymentContract.objects.filter(filters);
    },

    fetchEmploymentContract(context, pk) {
        return EmploymentContract.objects.get(pk);
    },

    fetchContracts(context, filters) {
        return Contracts.objects.filter(filters);
    },

    fetchContract(context, pk) {
        return Contracts.objects.get(pk);
    },

    fetchUnsignedContractsCount(context, filters) {
        return UnsignedContractsCount.objects.filter(filters);
    },

    createEmploymentContract(context, data) {
        return EmploymentContract.objects.create(data);
    },

    getEmploymentContract(context, pk) {
        return NextEmploymentContract.objects.get(pk);
    },

    getEmploymentContractDetails(context, pk) {
        return EmploymentContractDetails.objects.get(pk);
    },

    deleteContract(context, data) {
        return EmploymentContract.objects.delete(data);
    },

    updateContract(context, data) {
        let pk = data.pk;
        delete data.pk;

        const form = new FormData();
        (Object.keys(data)).forEach((key) => {
            form.append(key, data[key]);
        });
        form.append('removed', false);

        return EmploymentContract.objects.update(pk, form);
    },

    createContractSignature(context, data) {
        let signature = data.signature_file;
        if (signature) {
            return new Promise((resolve, reject) => {
                signature.save(async(blob) => {
                    let formData = new FormData();
                    formData.set('signature_file', blob, 'signature.png');
                    delete data.signature_file;
                    for (let key in data) {
                        formData.append(key, JSON.stringify(data[key]));
                    }
                    resolve(await JobOfferContractSignature.objects.create(formData));
                });
            });
        }
        else {
            return JobOfferContractSignature.objects.create({}, data).then(response => {
                return response;
            }).catch(error => {
                return error;
        });}
    },

    acknowledgeContract(context, data) {
        let signature = data.signature_file;
        if (signature) {
            return new Promise((resolve, reject) => {
                signature.save(async(blob) => {
                    let formData = new FormData();
                    formData.set('signature_file', blob, 'signature.png');
                    delete data.signature_file;
                    for (let key in data) {
                        formData.append(key, data[key]);
                    }
                    resolve(await ContractSignature.objects.create(formData));
                });
            });
        }
        else {
            return ContractSignature.objects.create({}, data).then(response => {
                return response;
            }).catch(error => {
                return error;
        });}
    },

    fetchAllContracts(context, filters) {
        return AllContracts.objects.filter(filters);
    },

    createContractComment(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return ContractComment.objects.create(form);
    },

    createContractCommentSeen(context, data) {
        const form = new FormData();
        for (let key in data) {
            form.append(key, data[key]);
        }
        return ContractCommentSeen.objects.create(form);
    },

    fetchContractComments(context, filters) {
        return ContractComment.objects.filter(filters);
    },

    fetchContractUnreadCommentsCount(context, pk) {
        return ContractUnreadCommentsCount.objects.get(pk);
    },

    async fetchContractCommentAmazonCredentials(context, filters) {
        return await ContractCommentAmazonCredentials.objects.filter(filters).then(amazon => {
            return amazon.amazon;
        });
    },

    updateSignature(context, data) {
        const { pk, payload } = data;
        const signature = payload.signature;
        let formData = new FormData();

        return new Promise((resolve) => {
            signature.save(async (blob) => {
                formData.append('signature_file', blob);
                formData.append('location', payload.location);
                formData.append('job_offer', payload.job_offer);
                let response = await Signature.objects.update({ pk: pk }, formData);
                resolve(response);
            });
        });
    },

    fetchEmploymentContractList(context, filters) {
        return EmploymentContractList.objects.filter(filters);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
